import { sessionIdsKey as t } from "../../../helpers/session.es.js";
import "@waitroom/utils";
const l = (s) => s, n = (s) => s.map, S = (s, e, o) => n(s)[t({ sessionID: e, sessionRecurrenceID: o })], m = (s, e, o) => !!n(s)[t({ sessionID: e, sessionRecurrenceID: o })], a = (s) => s.modal;
export {
  n as selectAllSessions,
  S as selectSessionById,
  m as selectSessionExists,
  a as selectSessionModal,
  l as selectSessionState
};
